import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';




 
import { Link } from 'react-router-dom';
import accountService from "../../api/account.service";
import paymentService from "../../api/payment.service";
import TestDetailComp from "../payment/TestDetailComp";














const VoucherListView = ({voucherListValue,voucherMasterDataValue,voucherDetailDataValue,isDataUpdatedValue}) => {

    const [voucherList, setVoucherList] = useState([]);
    const [voucherMasterData, setVoucherMasterData] = useState([]);
    const [voucherDetailData, setVoucherDetailData] = useState([]);

    


    const detailColumn = [
        {
            title: 'Account',
            dataIndex: 'account_name',
            key: 'account_name',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Tran Tag',
            dataIndex: 'tran_tag',
            key: 'tran_tag',
        },
    ]

  const columns = [
    {
      title: 'Voucher No',
      dataIndex: ['masterData', 'voucher_no'],
      key: 'voucher_no',
      
      
    },
    {
        title: 'Voucher Date',
        dataIndex: ['masterData', 'VoucherDate'],
        key: 'VoucherDate',
      },
    {
      title: 'Tran Type',
      dataIndex: ['masterData', 'tran_type'],
      key: 'tran_type',
    },
    {
      title: 'Narration',
      dataIndex: ['masterData', 'narration'],
      key: 'narration',
    },
    
    
    {
        title: "Detail",
        dataIndex: "detailsData",
        //render: (detailsData) =>  detailsData.map((data) => data.account_name).join(),
        render: (detailsData) => {
            return <Table columns={detailColumn}     pagination={false} className="voucherDetailTable" dataSource={detailsData} />
          },
    },
    
    
    
  
    
  ];


  /*
  useEffect(() => {
    const data = {
         formdata:{ from_date:fromdate,to_date:enddate,account_id:accountid }
        // formdata:{ from_date:'01/07/2022',to_date:'01/09/2022',tran_type:'', account_id:"" }
    }
    accountService.voucherList(data).then((res) => {
      
      const voucher_data = res[0].response_data;
      setVoucherList([voucher_data])
      setVoucherMasterData([voucher_data.masterData])
      setVoucherDetailData(voucher_data.detailsData)
    });
  }, [fromdate,enddate,accountid])
  */



  const expandedRowRender = () => {
    const detailColumns = [
      {
        title: 'Account',
       // dataIndex: 'account_name',
         dataIndex: [ 'detailsData','account_name'],
        key: 'account_name',
      },
      {
        title: 'Amount',
        //dataIndex: 'amount',
        //dataIndex: 'amount',
        dataIndex: [ 'detailsData','amount'],
        key: 'amount',
      },
      {
        title: 'Tag',
        //dataIndex: 'tran_tag',
        //dataIndex: 'tran_tag',
        dataIndex: [ 'detailsData','tran_tag'],
        key: 'tran_tag',
      },
    
      
    
    ];
    return <Table columns={detailColumns} dataSource={voucherList.detailsData} pagination={false} />;
  };


  useEffect(()=> {
  
    setVoucherList(voucherListValue)
    setVoucherMasterData(voucherMasterDataValue)
    setVoucherDetailData(voucherDetailDataValue)

    console.log("voucherDetailDataValue",voucherMasterDataValue)
},[isDataUpdatedValue])

  return (
    <>
      {/* <Table columns={columns} rowKey={list => list.masterData.vmasterID} dataSource={voucherList} /> */}
      
      <Table
        columns={columns}
        rowKey={list => list.masterData.vmasterID}
        // expandable={{
        //   expandedRowRender,
        //   defaultExpandedRowKeys: ['voucher_no'],
        // }}
        dataSource={voucherList}
        size="small"
      />
    </>
  );
};

export default VoucherListView